import { getFormedEltTranslation } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getFormedEltTranslation'
import { useMemo, useState } from 'react'

import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'
import { ModalDialog } from 'core-components/library/modalDialog'

import { StockImageGuideContent } from './components/stockImageGuideContent/StockImageGuideContent'

export const StockImageGuide = () => {
  const [show, setShow] = useState(false)

  const contentProps = useMemo(() => {
    return {
      onClose: () => setShow(false),
    }
  }, [])
  return (
    <div>
      <Button onClick={() => setShow(true)} variant={'contained'} color={'success'}>
        <Translation text={getFormedEltTranslation('stock-image-guide-open')} />
      </Button>
      <ModalDialog
        show={show}
        size="md"
        onClose={() => setShow(false)}
        content={StockImageGuideContent}
        contentProps={contentProps}
      />
    </div>
  )
}
